import { PREFIX_SCM_PATH } from "../constant/path";

export const FREE_GAS_API = {
  urlFreeGas: `${PREFIX_SCM_PATH}/free_gas`,
};
